import ErrorToast from "@components/Common/ErrorTost";
import { showSuccessToast } from "@components/Common/SuccessToast";
import {
    TOAST_LIMIT_DEFAULT,
    TOAST_LIMIT_WITH_ERRORS,
} from "@constants/index";
import { t } from "i18next";
import { toast } from "react-toastify";
import { handleArchiveType } from "../Types";

export function AssociateModeOfSale(
    shopsSaleSupportData: any[],
    selectedRowData: any
): any[] {
    if (!shopsSaleSupportData || !selectedRowData) return [];

    const idsAssociated: any[] = [];

    for (const element of shopsSaleSupportData) {
        if (element.subRows) {
            for (const sub of element.subRows) {
                if (sub.Id === selectedRowData.selectedRow.Id) {
                    idsAssociated.push(sub);
                }
            }
        }
    }

    return idsAssociated;
}

export function ArchivedArchivedSaleSupportFranchise(
    shopsSaleSupportData: any[]
): string[] {
    if (!shopsSaleSupportData) return [];

    const idsAssociated = shopsSaleSupportData.map(
        (element: any) => element.Id
    );
    return Array.from(new Set(idsAssociated));
}

export function ArchivedSaleSupport(shopsSaleSupportData: any[]): string[] {
    if (!shopsSaleSupportData) return [];

    const idsAssociated: string[] = [];

    for (const element of Object.values(shopsSaleSupportData)) {
        if (element && Array.isArray(element.subRows)) {
            for (const sub of element.subRows) {
                idsAssociated.push(sub.Id);
            }
        }
    }

    return Array.from(new Set(idsAssociated));
}

export const getAssociatedIds = (shopsSaleSupportData: any[]): string[] => {
    return shopsSaleSupportData.flatMap((el) =>
        el.subRows.map((element: any) => element.Id)
    );
};

export function getDataConfig({
    userData,
    selectedRowData,
    operatorID,
    uuidUser,
    state,
}: any) {
    const dataConfig = [
        {
            userId: userData.userId,
            shopId: [selectedRowData.selectedRow.shopId],
            franchiseId: userData.franchiseId,
            operatorId: operatorID,
            uuidUser: uuidUser,
            data: {
                [selectedRowData.selectedRow.Id]: {
                    id: selectedRowData.selectedRow.Id,
                    displayName: selectedRowData.selectedRow[t("Display name")],
                    shopId: userData.shopId,
                    support_de_vente:
                        selectedRowData.selectedRow[t("Sale support")],
                    tag: selectedRowData.selectedRow.Tag,
                    isFavorite: selectedRowData.selectedRow.isFavorite,
                    isActive: state,
                    isArchived: selectedRowData.selectedRow.isArchived,
                    advancedDisplayName:
                        selectedRowData.selectedRow.advancedDisplayName,
                },
            },
        },
    ];

    return dataConfig;
}

export const createBaseConfig = (
    userData: any,
    selectedRow: any,
    operatorID: string,
    uuidUser: any
) => ({
    userId: userData.userId,
    shopId: [selectedRow.shopId],
    franchiseId: userData.franchiseId,
    operatorId: operatorID,
    uuidUser: uuidUser,
});

export const createSaleSupportData = (
    saleSupport: any,
    overrides: Partial<{
        isFavorite: boolean;
        isActive: boolean;
        isArchived: boolean;
    }> = {}
) => ({
    id: saleSupport.Id,
    displayName: saleSupport[t("Display name")],
    shopId: saleSupport.shopId,
    support_de_vente: saleSupport[t("Sale support")],
    tag: saleSupport.Tag,
    isFavorite: overrides.isFavorite ?? saleSupport.isFavorite,
    isActive: overrides.isActive ?? saleSupport.isActive,
    isArchived: overrides.isArchived ?? saleSupport.isArchived,
    advancedDisplayName: saleSupport.advancedDisplayName,
});

export function archivedSaleSupport(shopsSaleSupportData: any) {
    let idsAssociated: any[] = [];
    if (shopsSaleSupportData !== undefined) {
        shopsSaleSupportData.forEach((element: any) => {
            element.subRows.forEach((el: any) => {
                idsAssociated.push(el.Id);
            });
        });
    }
    idsAssociated = [...new Set(idsAssociated)];
    return idsAssociated;
}

export function ArchivedSaleSupportFranchise(listFranchiseArchived: any) {
    let idsAssociated: any[] = [];
    if (listFranchiseArchived !== undefined) {
        listFranchiseArchived.forEach((element: any) => {
            idsAssociated.push(element.Id);
        });
    }
    idsAssociated = [...new Set(idsAssociated)];
    return idsAssociated;
}

export function saleSupportExistInShops(
    shopsSaleSupportData: any,
    selectedRows: any,
    oneShop: boolean,
    setIsArchivedValidationModalOpened: any
) {
    let isIdExist;
    let idsAssociated: any = [];

    shopsSaleSupportData.forEach((el: any) => {
        el.subRows.forEach((element: any) => {
            idsAssociated.push(element.Id);
        });
    });
    selectedRows.forEach((el: any) => {
        if (idsAssociated.includes(el.Id)) {
            isIdExist = true;
        }
    });

    if (isIdExist === true && !oneShop) {
        ErrorToast(
            `${t(
                "Please note that you cannot archive an item assigned to stores."
            )!}`
        );
    } else {
        setIsArchivedValidationModalOpened(true);
    }
}


export async function handleArchiveSaleSupportHelper({
    userID,
    franchiseID,
    operatorID,
    shopID,
    uuidUser,
    isArchived,
    selectedRows,
    t,
    fetchGlobal,
    setIsLoading,
    setLimit,
    setShopDataIsUpdated,
}: handleArchiveType): Promise<{ success: boolean; error?: string }> {
    try {
        setIsLoading(true);
        toast.dismiss();
        setLimit(TOAST_LIMIT_DEFAULT);

        // Prepare sale support items
        const saleSupportItems: any[] = selectedRows
            .filter((el: any) => el[t("Shop")] === undefined)
            .map((el: any) => ({
                id: el.Id,
                shopId: el.shopId || shopID || "0",
                displayName: el[t("Display name")],
                support_de_vente: el[t("Sale support")],
                tag: el.Tag,
                isFavorite: el.isFavorite,
                advancedDisplayName: el.advancedDisplayName,
            }));

        // Remove duplicates
        const uniqueItems = saleSupportItems.filter(
            (item, index, self) =>
                index ===
                self.findIndex(
                    (support) => support.id === item.id && support.shopId === item.shopId
                )
        );

        if (uniqueItems.length === 0) {
            setIsLoading(false);
            return { success: false, error: "No items to archive" };
        }

        // Call the unified archive endpoint
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/archiveSaleSupport`;
        const result = await fetchGlobal<any>(apiUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                userId: userID,
                franchiseId: franchiseID,
                operatorId: operatorID,
                uuidUser: uuidUser,
                isArchived: isArchived,
                saleSupportItems: uniqueItems,
            }),
        });

        // Check for API errors
        if (result?.error) {
            throw new Error(result.error);
        }

        // Check for specific validation errors
        const hasErrors =
            (result?.usedItems && result.usedItems.length > 0) ||
            (result?.favoriteItems && result.favoriteItems.length > 0);

        if (result?.usedItems && result.usedItems.length > 0) {
            setLimit(TOAST_LIMIT_WITH_ERRORS);
            ErrorToast(
                `${t("Attention, you cannot archive a used element.")}`
            );
        }

        if (result?.favoriteItems && result.favoriteItems.length > 0) {
            setLimit(TOAST_LIMIT_WITH_ERRORS);
            ErrorToast(
                t(
                    `Please note, you cannot archive a favorite sales support`
                )
            );
        }

        // Show success message if at least one item was archived/unarchived
        if (result?.archivedCount > 0) {
            if (hasErrors) setLimit(TOAST_LIMIT_WITH_ERRORS);
            showSuccessToast(
                !isArchived
                    ? `${t("Sale support is successfully unarchived")!}`
                    : `${t("Sale Support is successfully archived")!}`
            );
            if (!isArchived && setShopDataIsUpdated) {
                setShopDataIsUpdated(true);
            }
        }

        setIsLoading(false);
        return { success: true };
    } catch (e: any) {
        setIsLoading(false);
        ErrorToast(`${t("There's an error")!}`);
        return { success: false, error: e.message };
    }
}
